var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.$vuetify.breakpoint.mdAndUp)?_c('div',{staticClass:"text-center",staticStyle:{"margin-top":"-20px"}},[_c('p',{staticStyle:{"font-family":"Brush Script MT, Brush Script Std, cursive"},style:({
    fontSize: _vm.$vuetify.breakpoint.mdAndUp ? '4rem' : '3rem',
  })},[_vm._v(" "+_vm._s(_vm.title)+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }